export const MOBILE_BANNER_LOCATION = ["Mobile Main", "Mobile Store"];
export const WEB_BANNER_LOCATION = ["Web Main", "Web Home", "Web Store"];
